import { createFileRoute, redirect } from "@tanstack/react-router";
import { TemplateForm } from "@/features/quotation-templates/TemplateForm";
import { canCreatePurchaseIndent } from "@/lib/roles";
import { currentUserQueryOptions } from "@/hooks/useCurrentUser";

export const Route = createFileRoute("/_authenticated/quotation-templates/new")({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(currentUserQueryOptions());
    if (!canCreatePurchaseIndent(me.roles)) throw redirect({ to: "/quotation-templates" });
  },
  component: NewTemplate,
});

function NewTemplate() {
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold tracking-tight">New Quotation Template</h1>
      <TemplateForm />
    </div>
  );
}
